// eslint-disable-next-line import/no-extraneous-dependencies
import React, { useEffect, useState } from 'react'
import { Input, Button, Form, notification, Carousel } from 'antd'
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons'
import { history } from 'index'
import { getLoggedInUserInfo, getGifUrl } from 'utils'
import Cookies from 'js-cookie'
import { useSelector, useDispatch } from 'react-redux'
import { login } from 'services/axios/auth'
import { isEmpty } from 'lodash'
import { fetchTeamPendingLeaveRequest } from 'redux/empLeave/action'
import { userRoleEnums } from 'enums/userRole'
// eslint-disable-next-line import/no-extraneous-dependencies
import confetti from 'canvas-confetti'
import axios from 'axios'
import { getEventsNotification } from 'services/axios/events'
import microsoftLogo from '../../../../../public/resources/images/microsoftLogo/microsoft.png'
import style from '../style.module.scss'
import { useMsal } from './msalContext'

const Login = () => {
  const [form] = Form.useForm()
  const isLoading = useSelector((state) => state?.settings?.isLoading)
  const dispatch = useDispatch()
  const teamPendingLeave = useSelector((state) => state?.empLeaveData?.teamPendingLeave)
  const [isLoggingIn, setIsLoggingIn] = useState(false)
  const [showEmailLogin, setShowEmailLogin] = useState(false)
  const msalInstance = useMsal()

  useEffect(() => {
    const userRole = getLoggedInUserInfo()?.userRole
    if (userRole) {
      history.push('/dashboard')
    }
  }, [])

  useEffect(() => {
    const userRole = getLoggedInUserInfo()?.userRole
    if (userRole && teamPendingLeave > 0) {
      notification.success({
        message: 'Leave Requests Pending',
        description: 'Employees leave request are pending',
      })
    }
  }, [teamPendingLeave])

  const showEventNotifications = (events) => {
    if (!events || events.length === 0) return

    const backdropOverlay = document.createElement('div')
    backdropOverlay.id = 'event-notification-backdrop'
    backdropOverlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.5);
      backdrop-filter: blur(8px);
      -webkit-backdrop-filter: blur(8px);
      z-index: 999;
      pointer-events: none;
    `
    document.body.appendChild(backdropOverlay)

    // Confetti animation
    const duration = 10 * events.length * 1000
    const animationEnd = Date.now() + duration
    const defaults = { startVelocity: 35, spread: 360, ticks: 60, zIndex: 1001 }

    const randomInRange = (min, max) => Math.random() * (max - min) + min

    const interval = setInterval(() => {
      const timeLeft = animationEnd - Date.now()
      if (timeLeft <= 0) {
        clearInterval(interval)
        return
      }

      const particleCount = 200 * (timeLeft / duration)

      confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
      })

      confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
      })
    }, 250)

    notification.open({
      key: 'eventNotification',
      message: (
        <div style={{ textAlign: 'center', margin: '12px 0 4px' }}>
          <span style={{ fontSize: '26px', fontWeight: 'bold', color: '#ffffff' }}>
            <span role="img" aria-label="Party Popper">
              🎉
            </span>{' '}
            Events{' '}
            <span role="img" aria-label="Party Popper">
              🎉
            </span>
          </span>
        </div>
      ),
      icon: null,
      description: (
        <div style={{ padding: '16px 20px', marginBottom: '30px', marginLeft: '2px' }}>
          <Carousel autoplay autoplaySpeed={4000}>
            {events.map(({ eventName, gifUrl }, index) => (
              <div
                key={index}
                style={{
                  textAlign: 'center',
                  padding: '20px',
                  borderRadius: '15px',
                  background: 'linear-gradient(135deg, #1b2735 0%, #090a0f 100%)',
                  boxShadow: 'inset 0 0 0.5px rgba(255,255,255,0.1)',
                }}
              >
                <h3
                  style={{
                    fontSize: '22px',
                    fontWeight: 600,
                    marginBottom: '20px',
                    color: 'white',
                    textAlign: 'center',
                    textShadow: '0 1px 3px rgba(0,0,0,0.6)',
                  }}
                >
                  {eventName}
                </h3>
                <img
                  src={gifUrl}
                  alt={`${eventName} GIF`}
                  style={{
                    maxWidth: '500px',
                    minWidth: '400px',
                    width: '300px',
                    maxHeight: '250px',
                    borderRadius: '12px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                    marginLeft: '30px',
                  }}
                />
              </div>
            ))}
          </Carousel>
        </div>
      ),
      duration: duration / 1000,
      style: {
        position: 'fixed',
        top: '100px',
        left: '50%',
        transform: 'translateX(-50%)',
        maxWidth: '500px',
        width: '100%',
        padding: 0,
        borderRadius: '20px',
        backgroundColor: '#C2CCC5',
        boxShadow: '0 12px 40px rgba(0,0,0,0.6)',
        zIndex: 1000,
        color: '#ffffff',
        overflow: 'hidden',
      },
      onClose: () => {
        const backdrop = document.getElementById('event-notification-backdrop')
        if (backdrop) backdrop.remove()
        clearInterval(interval)
      },
    })

    setTimeout(() => {
      notification.close('eventNotification')
      const backdrop = document.getElementById('event-notification-backdrop')
      if (backdrop) backdrop.remove()
      clearInterval(interval)
    }, duration)
  }

  const fetchAndShowEvents = async (loginDate) => {
    try {
      const eventsResponse = await getEventsNotification()
      const eventData = eventsResponse?.data?.eventData

      if (eventData && eventData.length > 0 && loginDate) {
        const formattedLoginDate = new Date(
          new Date().getFullYear(),
          loginDate?.month - 1,
          loginDate?.day,
        )

        const matchingEvents = eventData
          .filter((event) => {
            const eventStartDate = new Date(event?.eventStartDate)
            return (
              eventStartDate.getMonth() === formattedLoginDate.getMonth() &&
              eventStartDate.getDate() === formattedLoginDate.getDate()
            )
          })
          .map((event) => ({
            eventName: event.eventName,
            gifUrl: getGifUrl(event.eventName),
          }))

        if (matchingEvents.length > 0) {
          showEventNotifications(matchingEvents)
        }
      }
    } catch (error) {
      console.error('Error fetching events:', error)
    }
  }

  const onFinish = async (values) => {
    const response = await login(values)
    if (response?.data?.token) {
      const { token, permissions, user, loginDate } = response.data
      Cookies.set('accessToken', token, { expires: 1 })
      Cookies.set('permissions', JSON.stringify(permissions), { expires: 1 })

      const userInformation = getLoggedInUserInfo()
      userInformation.email = user
      const userRole = userInformation?.userRole
      const userId = userInformation?.userId

      if (isEmpty(permissions) && userRole !== userRoleEnums?.SUPER_ADMIN) {
        notification.warning({
          message: 'Warning',
          description: 'Please contact your administrator',
        })
      } else {
        await dispatch(fetchTeamPendingLeaveRequest(userId))

        if (userRole === 'trainee') {
          history.push('/attendance')
        } else {
          history.push('/dashboard')
        }

        notification.success({
          message: 'Success',
          description: response?.data?.message,
        })

        // 🎉 Show Events
        setTimeout(() => {
          fetchAndShowEvents(loginDate)
        }, 1000)
      }
    }
  }

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo)
  }

  const handleMicrosoftLogin = async () => {
    if (isLoggingIn) {
      notification.info({
        message: 'Login in Progress',
        description: 'A login attempt is already in progress. Please wait...',
      })
      return
    }

    setIsLoggingIn(true)

    try {
      const activeAccount = msalInstance.getActiveAccount()
      if (activeAccount) {
        try {
          const silentResult = await msalInstance.acquireTokenSilent({
            scopes: ['User.Read', 'Mail.Read'],
            account: activeAccount,
          })
          await handleAuthenticationSuccess(silentResult)
          return
        } catch (err) {
          console.warn('Silent token acquisition failed:', err.message)
        }
      }

      notification.info({
        key: 'msLoginNotification',
        message: 'Microsoft Login',
        description: 'Opening Microsoft login window...',
        duration: 0,
      })

      const loginResponse = await msalInstance.loginPopup({
        scopes: ['User.Read', 'Mail.Read'],
      })

      notification.close('msLoginNotification')
      await handleAuthenticationSuccess(loginResponse)
    } catch (interactionError) {
      notification.close('msLoginNotification')
      notification.error({
        message: 'Login Failed',
        description: interactionError.message || 'Microsoft login error',
      })
    } finally {
      setIsLoggingIn(false)
    }
  }

  const handleAuthenticationSuccess = async (authResponse) => {
    const { account, accessToken } = authResponse
    msalInstance.setActiveAccount(account)

    try {
      notification.info({
        key: 'tokenVerification',
        message: 'Verifying Account',
        description: 'Verifying your Microsoft account...',
        duration: 0,
      })

      let msalVerifyTokenUrl
      if (process.env.NODE_ENV === 'development') {
        msalVerifyTokenUrl = `${process.env.REACT_APP_DEV_BASE_URL}auth/verifyToken`
      } else {
        msalVerifyTokenUrl = `${process.env.REACT_APP_PROD_BASE_URL}/auth/verifyToken`
      }

      const response = await axios.post(msalVerifyTokenUrl, {
        token: accessToken,
      })

      notification.close('tokenVerification')

      if (response.data.token) {
        const { token, permissions, loginDate } = response.data

        Cookies.set('accessToken', token, { expires: 1 })
        if (permissions) Cookies.set('permissions', JSON.stringify(permissions), { expires: 1 })

        const userInformation = getLoggedInUserInfo()
        const userRole = userInformation?.userRole
        const userId = userInformation?.userId

        if (isEmpty(permissions) && userRole !== userRoleEnums?.SUPER_ADMIN) {
          notification.warning({
            message: 'Warning',
            description: 'Please contact your administrator for proper permissions',
          })
        } else {
          if (userId) await dispatch(fetchTeamPendingLeaveRequest(userId))
          history.push('/dashboard')
        }

        notification.success({
          message: 'Microsoft Login Successful',
          description: response.data.message || 'Welcome back!',
        })

        // 🎉 Show Events
        setTimeout(() => {
          fetchAndShowEvents(loginDate)
        }, 1000)
      } else {
        notification.error({
          message: 'Microsoft Login Failed',
          description: response.data.message || 'Token validation failed',
        })
      }
    } catch (error) {
      notification.close('tokenVerification')
      notification.error({
        message: 'Login Failed',
        description: error.response?.data?.message || 'Error verifying the token',
      })
    }
  }

  const toggleEmailLogin = () => setShowEmailLogin(!showEmailLogin)

  return (
    <div>
      <div className="pt-2 pb-5 text-center">
        <div className={style.logo}>
          <h2>Value Portal</h2>
        </div>
      </div>
      <div className={`card ${style.container}`}>
        <div className="text-dark font-size-32 mb-3">Sign In</div>

        {!showEmailLogin && (
          <div className="mb-4">
            <div className="mb-4">Sign in with your Microsoft account</div>
            <Button
              type="default"
              className="text-center w-100"
              onClick={handleMicrosoftLogin}
              loading={isLoggingIn}
              disabled={isLoading || isLoggingIn}
            >
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <img
                  src={microsoftLogo}
                  alt="Microsoft Logo"
                  style={{ width: 24, height: 24, marginRight: 8, marginTop: '-1px' }}
                />
                <strong>Continue with Microsoft</strong>
              </div>
            </Button>

            <div className="mt-3 mb-3 text-center">OR</div>

            <Button
              type="primary"
              className="text-center w-100"
              onClick={toggleEmailLogin}
              disabled={isLoading || isLoggingIn}
            >
              <strong>Login with Email</strong>
            </Button>
          </div>
        )}

        {showEmailLogin && (
          <>
            <div className="mb-4">Sign in with credentials</div>
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              className="mb-4"
              initialValues={{ email: '', password: '' }}
            >
              <Form.Item
                name="email"
                label="Email"
                rules={[{ required: true, message: 'Please input your email id' }]}
              >
                <Input placeholder="Email" />
              </Form.Item>
              <Form.Item
                label="Password"
                name="password"
                rules={[{ required: true, message: 'Please input your password' }]}
              >
                <Input.Password
                  placeholder="Password"
                  iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                />
              </Form.Item>
              <div className="mb-4">
                <a href="/auth/forgot-password">Forget Password?</a>
              </div>
              <Button
                type="primary"
                className="text-center w-100 btn btn-success"
                htmlType="submit"
                loading={isLoading}
                disabled={isLoading || isLoggingIn}
              >
                <strong>Sign in</strong>
              </Button>
            </Form>

            <div className="text-center">
              <Button type="link" onClick={toggleEmailLogin}>
                Back to Microsoft Login
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default Login
